<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <v-card style="position: relative;">
      <v-overlay
        absolute
        :value="loading"
        class="text-center"
      >
        <v-progress-circular
          indeterminate
          :size="50"
          color="primary"
        />
        <p class="text-overline white--text mt-4">
          working...
        </p>
      </v-overlay>
      <v-card-title>
        <span class="text-h5">Select Team</span>
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedTeam"
          :items="teams"
          label="Team"
          required
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          text
          @click="_ => closeDialog()"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="_ => onSelected()"
        >
          Select
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'SelectTeamDialog',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      selectedTeam: null,
    }
  },

  computed: {

    dialog: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
      },
    },

    teams () {
      return this.getCachedDropdown('teams/active_teams')
    },

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  created () {
    this.loadData()
  },

  methods: {

    closeDialog () {
      this.dialog = false
    },

    loadData () {
      this.getDropdownOptions({ path: 'teams/active_teams' })
    },

    onSelected () {
      this.$emit('selected', this.selectedTeam)
      this.closeDialog()
    },

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
